import React, { FC, useState } from 'react';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { AccountServce } from 'services/upload/file-upload';
import { AuthService } from 'services/auth/auth';
import { IMe } from 'core/interface/me';
import { useSelector } from 'react-redux';
import { IAvatarPopup } from 'core/interface/avatarPopup';
import { UpdateUser } from '../../../../redux/slices/user';
import { store } from '../../../../redux/store';
import ImagePicker from 'components/imagePicker';

import './Index.scss';

const AvatarPopup: FC<IAvatarPopup> = ({ t, onPopupClose }): JSX.Element => {
  const me = useSelector((state: IMe) => state.user).user;
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { dispatch } = store;

  const handleAvatarSave = async (): Promise<void> => {
    if (!selectedFile) return;

    setLoading(true);
    const formData = new FormData();
    formData.append('avatar', selectedFile);
    try {
      await AccountServce.updateAccount(me.id, formData);
      const res = await AuthService.getAccount();
      dispatch(UpdateUser(res));
      onPopupClose(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="av">
      <div className="av__content">
        {me?.avatar && !selectedFile && (
          <img src={me?.avatar} alt="" className="cropper" />
        )}
        <ImagePicker setLogo={setSelectedFile} logo={selectedFile} max={1} />
        <Button
          isLoading={loading}
          onClick={handleAvatarSave}
          t={t}
          title="Save"
          className="av__content-save"
          disabled={!selectedFile}
        />
      </div>
    </div>
  );
};

export default AvatarPopup;
